import { MoreOutlined } from '@ant-design/icons'
import { Styles } from '@types'
import { Button, Dropdown, Menu, Table, TableColumnType, TablePaginationConfig } from 'antd'
import { Additions } from 'gadjet-v2-types/dist/model'
import { Pagination } from 'gadjet-v2-types/dist/type'

import { krw } from '@utils/format'
import { netPriceToVAT } from '@utils/price'

import { BranchAdditionAction } from '@pages/Branch/AdditionPage'

import TableTotalRows from '@components/atoms/TableTotalRows'
import TableWrapper from '@components/atoms/TableWrapper'
import TableColumnItem from '@components/molecules/TableColumnItem'

type Props = {
  loading: boolean
  total: number
  pagination: Pagination
  additions: Additions[]
  onChangePagination: (pagination: Pagination) => void
  onAction: (action: BranchAdditionAction, addtionId: number) => void
  onChangeActiveStatus: (status: boolean, rentalId: number) => void
}
export default function BranchAdditionListTable({
  loading,
  total,
  pagination,
  additions,
  onChangePagination,
  onAction,
  onChangeActiveStatus,
}: Props): JSX.Element {
  const onChange = (_pagination: TablePaginationConfig) => onChangePagination({ ...pagination, ..._pagination })

  const columns: TableColumnType<Additions>[] = [
    { key: 'name', dataIndex: 'name', title: '이름' },
    {
      key: 'price',
      dataIndex: 'price',
      title: '비용',
      align: 'right',
      render: (price) => {
        return (
          <>
            <TableColumnItem label="공급가액" value={krw(price)} />
            <TableColumnItem label="부가세" value={krw(netPriceToVAT(price))} />
          </>
        )
      },
    },
    {
      key: 'additionId',
      dataIndex: 'additionId',
      title: '사용 중',
      render: (_, { additionId }) => <Button onClick={() => onAction('contract', additionId)}>계약내역</Button>,
    },
    {
      key: 'isActive',
      dataIndex: 'isActive',
      title: '활성 / 비활성',
      align: 'center',
      width: '150px',
      render: (isActive, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="true" onClick={() => onChangeActiveStatus(true, record.additionId)}>
                활성
              </Menu.Item>
              <Menu.Item key="false" onClick={() => onChangeActiveStatus(false, record.additionId)}>
                비활성
              </Menu.Item>
            </Menu>
          }
          placement="bottomRight"
          trigger={['click']}
        >
          <Button className={isActive ? 'green-btn' : 'red-btn'}>{isActive ? '활성' : '비활성'}</Button>
        </Dropdown>
      ),
    },
    {
      key: 'additionId',
      dataIndex: 'additionId',
      title: '',
      width: '80px',
      render: (_, { additionId }) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="update" onClick={() => onAction('update', additionId)}>
                수정
              </Menu.Item>
              <Menu.Item key="delete" onClick={() => onAction('delete', additionId)}>
                삭제
              </Menu.Item>
            </Menu>
          }
          placement="bottomRight"
          trigger={['click']}
        >
          <Button icon={<MoreOutlined />} size="large" type="text" />
        </Dropdown>
      ),
    },
  ]

  return (
    <TableWrapper>
      <Table<Additions>
        loading={loading}
        style={styles.table}
        scroll={{ x: true }}
        rowKey={({ additionId }) => `${additionId}`}
        dataSource={additions}
        columns={columns}
        onChange={onChange}
        pagination={{
          total,
          position: ['bottomCenter'],
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: true,
          showTotal: (total) => <TableTotalRows total={total} />,
        }}
      />
    </TableWrapper>
  )
}

const styles: Styles = {
  table: { whiteSpace: 'pre-wrap', wordBreak: 'keep-all' },
}
